import { call, put, select } from 'redux-saga/effects';

import * as FavoritesApi from 'api/favorites';
import { DATA_BAG } from 'defs/offlineAvailability';
import Sequences from 'defs/sequences';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionCreators as favoritesAC, getFavoritesMetaDataQuery } from 'store/favorites';
import { getIsMigrosAuthenticated } from 'store/login';
import { actionCreators as offlineAvailabilityAC } from 'store/offlineAvailability';
import { actionCreators as sequencesAC } from 'store/sequences';

export function* loadFavoritesData() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	yield put(sequencesAC.doStartSequence(Sequences.FAVORITES_IS_LOADING));

	try {
		const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);

		if (!isMigrosAuthenticated) {
			return void 0;
		}

		const oldQuery = yield select(getFavoritesMetaDataQuery);
		const favoritesList = yield call(FavoritesApi.fetchFavoritesIds);

		yield put(favoritesAC.doLoadFavoritesMetaDataSuccess(favoritesList));

		const query = yield select(getFavoritesMetaDataQuery);

		const dynamicProducts = favoritesList
			.map((favoriteItem: any) => (favoriteItem.type === 'PRODUCT_DYNAMIC' ? favoriteItem : null))
			.filter(Boolean)
			.map((validProductItem: any) => ({
				...validProductItem,
				contentType: validProductItem.type,
				productId: parseInt(validProductItem.externalId, 10) || 0,
				type: void 0,
			}));

		if (query && query !== oldQuery) {
			const favorites = yield call(FavoritesApi.fetchFavorites.bind(null, query));
			yield put(offlineAvailabilityAC.doRegisterDataBag(DATA_BAG.FAVORITES));
			yield put(favoritesAC.doLoadFavoritesDataSuccess([...favorites, ...dynamicProducts]));
		} else if (!query) {
			yield put(favoritesAC.doLoadFavoritesDataSuccess([]));
		}
	} catch (error) {
		yield put(favoritesAC.doLoadFavoritesDataError(error));
	}

	yield put(sequencesAC.doFinishSequence(Sequences.FAVORITES_IS_LOADING));
}

export function* loadSelectedFavoritesData(action: ReturnType<typeof favoritesAC.doLoadSelectedFavoriteData>) {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	yield put(sequencesAC.doStartSequence(Sequences.FAVORITE_IS_LOADING));

	try {
		const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
		if (!isMigrosAuthenticated) {
			return void 0;
		}

		const { id, contentType } = action;
		const query = `${id}:${contentType}`;
		const favorites = yield call(FavoritesApi.fetchFavorites.bind(null, query));
		// TODO: FavoritesAPI argument #3 should be string and not number!
		const favoriteMeta = yield call(FavoritesApi.checkIsFavorite.bind(null, contentType as any, id));

		yield put(
			favoritesAC.doLoadSelectedFavoriteDataSuccess({
				...(favorites[0] || {}),
				favoriteMeta: {
					...favoriteMeta,
					favorite: void 0,
					isFavorite: favoriteMeta.favorite,
				},
			})
		);
	} catch (error) {
		yield put(favoritesAC.doLoadSelectedFavoriteDataError(error));
	}

	yield put(sequencesAC.doFinishSequence(Sequences.FAVORITE_IS_LOADING));
}
